/* eslint func-style: "off" */
/* eslint require-jsdoc: "off" */
/* eslint valid-jsdoc: "off" */
/**
 * 0:摄像头和麦克风都关闭
 * 1:开摄像头，关麦克风
 * 2:关摄像头，开麦克风
 * 3:摄像头和麦克风都开启
*/
export function getDeviceStatus (video, audio) {
    let deviceStatus = null;
    if (!video && !audio) deviceStatus = 0;
    if (video && !audio) deviceStatus = 1;
    if (!video && audio) deviceStatus = 2;
    if (video && audio) deviceStatus = 3;
    return deviceStatus;
}
